export enum ToastSeverity {
	Success = 'success',
	Error = 'error',
	Warning = 'warning',
	Info = 'info'
}
